import React, { createContext, useState, useEffect, useContext } from "react";

const LS_KEY = "vochica_store";

// default shape: { storeId, setStoreId, viewMode, setViewMode }
export const StoreContext = createContext({
  storeId: null,
  setStoreId: () => { },
  viewMode: "avg",
  setViewMode: () => { }
});

export const StoreProvider = ({ children }) => {
  const [storeId, setStoreId] = useState(() => {
    try {
      return localStorage.getItem(LS_KEY) || null;
    } catch {
      return null;
    }
  });

  // Global View Mode (avg vs sum) — Default is 'avg'
  const [viewMode, setViewMode] = useState("avg");

  useEffect(() => {
    try {
      if (storeId) localStorage.setItem(LS_KEY, storeId);
      else localStorage.removeItem(LS_KEY);
    } catch {
      /* ignore */
    }
  }, [storeId]);

  console.log("DEBUG: StoreProvider rendering with value:", { storeId, setStoreId, viewMode });

  return (
    <StoreContext.Provider value={{ storeId, setStoreId, viewMode, setViewMode }}>
      {children}
    </StoreContext.Provider>
  );
};

export const useStore = () => useContext(StoreContext);
